import React from 'react';
import type {TaskAssignmentSimpleResponse} from 'src/api/ProactApiClient';
import {ModuleEnum} from 'src/api/ProactApiClient';
import {ActionContents} from 'src/app/actions/ActionContents';
import {useActionView} from 'src/app/actions/useActionView';
import {ViewLinkedWorkflowSection} from 'src/app/workflows/ViewLinkedWorkflowSection';
import {Stack} from 'src/design/atoms/Stack';
import {Text} from 'src/design/atoms/Text';
import {ErrorAlert} from 'src/design/molecules/ErrorAlert';
import {SideDrawer} from 'src/design/organisms/SideDrawer';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import {parseErrorMessage} from 'src/shared/utils/parseErrorMessage';

export interface ActionPreviewProps {
  item: TaskAssignmentSimpleResponse;
  onClose: () => void;
}

export const ActionPreview: React.FC<ActionPreviewProps> = ({item, onClose}) => {
  const {
    viewItem,
    viewAssignment,
    isLoading,
    error,
    refetch,
    formMeta,
    formData,
    pills,
  } = useActionView(item.taskId);

  return (
    <>
      <SideDrawer.Header
        title={viewItem?.subject ?? item.taskDefinition.subject}
        badges={pills}
        fullPageHref={PathUtility.ActionView(item.taskId, 'content')}
      />
      <SideDrawer.Body loading={isLoading}>
        {error ? (
          <ErrorAlert mt={0} message={parseErrorMessage(error)} />
        ) : viewItem ? (
          <Stack gap="md">
            <ActionContents
              module={ModuleEnum.Actions}
              formData={formData}
              formMeta={formMeta}
              item={viewItem}
              assignment={viewAssignment}
              onRefreshTransition={refetch}
              onOfflineQueued={onClose}
              onRedirect={onClose}
            />
            <ViewLinkedWorkflowSection taskDefinitionId={viewItem.id} />
          </Stack>
        ) : (
          !isLoading && (
            <Text c="dimmed" size="sm">
              This action is no longer available.
            </Text>
          )
        )}
      </SideDrawer.Body>
    </>
  );
};
